import { useMemo, useState } from "react"

import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface UsePalletSearchReturn {
  searchTerm: string
  setSearchTerm: (term: string) => void
  filteredPallets: GoodsReceiptPallet[]
}

export const usePalletSearch = (pallets: GoodsReceiptPallet[]): UsePalletSearchReturn => {
  const [searchTerm, setSearchTerm] = useState("")

  const filteredPallets = useMemo(() => {
    if (!searchTerm.trim()) return pallets

    const lowerSearch = searchTerm.toLowerCase()

    return pallets.filter((pallet) => {
      if (!pallet) return false

      const productId = pallet.goodsReceiptPalletRow?.product?.publicId?.toLowerCase() || ""
      if (productId.includes(lowerSearch)) return true

      const referenceId = String(pallet.referenceId).toLowerCase()
      if (referenceId.includes(lowerSearch)) return true

      const lotNumbers =
        pallet.goodsReceiptPalletRow?.lots?.map((lot) => lot?.lotNumber?.toLowerCase() || "").join(" ") || ""
      if (lotNumbers.includes(lowerSearch)) return true

      return false
    })
  }, [pallets, searchTerm])

  return {
    searchTerm,
    setSearchTerm,
    filteredPallets,
  }
}
